import(/* webpackMode: "eager", webpackExports: ["ShouldRenderTabs"] */ "/app/node_modules/@payloadcms/next/dist/elements/DocumentHeader/Tabs/ShouldRenderTabs.js");
;
import(/* webpackMode: "eager", webpackExports: ["DocumentTabLink"] */ "/app/node_modules/@payloadcms/next/dist/elements/DocumentHeader/Tabs/Tab/TabLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["VersionsPill"] */ "/app/node_modules/@payloadcms/next/dist/elements/DocumentHeader/Tabs/tabs/VersionsPill/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["DefaultNavClient"] */ "/app/node_modules/@payloadcms/next/dist/elements/Nav/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["NavHamburger"] */ "/app/node_modules/@payloadcms/next/dist/elements/Nav/NavHamburger/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["NavWrapper"] */ "/app/node_modules/@payloadcms/next/dist/elements/Nav/NavWrapper/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["SettingsMenuButton"] */ "/app/node_modules/@payloadcms/next/dist/elements/Nav/SettingsMenuButton/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["NavHamburger"] */ "/app/node_modules/@payloadcms/next/dist/templates/Default/NavHamburger/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Wrapper"] */ "/app/node_modules/@payloadcms/next/dist/templates/Default/Wrapper/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["AccountClient"] */ "/app/node_modules/@payloadcms/next/dist/views/Account/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["ResetPreferences"] */ "/app/node_modules/@payloadcms/next/dist/views/Account/ResetPreferences/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSelector"] */ "/app/node_modules/@payloadcms/next/dist/views/Account/Settings/LanguageSelector.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToggleTheme"] */ "/app/node_modules/@payloadcms/next/dist/views/Account/ToggleTheme/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["APIViewClient"] */ "/app/node_modules/@payloadcms/next/dist/views/API/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["CreateFirstUserClient"] */ "/app/node_modules/@payloadcms/next/dist/views/CreateFirstUser/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["ModularDashboardClient"] */ "/app/node_modules/@payloadcms/next/dist/views/Dashboard/Default/ModularDashboard/index.client.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@payloadcms/next/dist/views/Edit/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/app/node_modules/@payloadcms/next/dist/views/ForgotPassword/ForgotPasswordForm/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/app/node_modules/@payloadcms/next/dist/views/Login/LoginForm/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["LogoutClient"] */ "/app/node_modules/@payloadcms/next/dist/views/Logout/LogoutClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["NotFoundClient"] */ "/app/node_modules/@payloadcms/next/dist/views/NotFound/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["ResetPasswordForm"] */ "/app/node_modules/@payloadcms/next/dist/views/ResetPassword/ResetPasswordForm/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToastAndRedirect"] */ "/app/node_modules/@payloadcms/next/dist/views/Verify/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["DefaultVersionView"] */ "/app/node_modules/@payloadcms/next/dist/views/Version/Default/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Collapsible"] */ "/app/node_modules/@payloadcms/next/dist/views/Version/RenderFieldsToDiff/fields/Collapsible/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["DateDiffComponent"] */ "/app/node_modules/@payloadcms/next/dist/views/Version/RenderFieldsToDiff/fields/Date/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Group"] */ "/app/node_modules/@payloadcms/next/dist/views/Version/RenderFieldsToDiff/fields/Group/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Iterable"] */ "/app/node_modules/@payloadcms/next/dist/views/Version/RenderFieldsToDiff/fields/Iterable/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Row"] */ "/app/node_modules/@payloadcms/next/dist/views/Version/RenderFieldsToDiff/fields/Row/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Select"] */ "/app/node_modules/@payloadcms/next/dist/views/Version/RenderFieldsToDiff/fields/Select/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs"] */ "/app/node_modules/@payloadcms/next/dist/views/Version/RenderFieldsToDiff/fields/Tabs/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/app/node_modules/@payloadcms/next/dist/views/Version/RenderFieldsToDiff/fields/Text/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["RenderVersionFieldsToDiff"] */ "/app/node_modules/@payloadcms/next/dist/views/Version/RenderFieldsToDiff/RenderVersionFieldsToDiff.js");
;
import(/* webpackMode: "eager", webpackExports: ["VersionDrawerCreatedAtCell"] */ "/app/node_modules/@payloadcms/next/dist/views/Version/SelectComparison/VersionDrawer/CreatedAtCell.js");
;
import(/* webpackMode: "eager", webpackExports: ["VersionPillLabel"] */ "/app/node_modules/@payloadcms/next/dist/views/Version/VersionPillLabel/VersionPillLabel.js");
;
import(/* webpackMode: "eager", webpackExports: ["AutosaveCell"] */ "/app/node_modules/@payloadcms/next/dist/views/Versions/cells/AutosaveCell/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["CreatedAtCell"] */ "/app/node_modules/@payloadcms/next/dist/views/Versions/cells/CreatedAt/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["IDCell"] */ "/app/node_modules/@payloadcms/next/dist/views/Versions/cells/ID/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["VersionsViewClient"] */ "/app/node_modules/@payloadcms/next/dist/views/Versions/index.client.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@payloadcms/richtext-lexical/dist/exports/client/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["S3ClientUploadHandler"] */ "/app/node_modules/@payloadcms/storage-s3/dist/client/S3ClientUploadHandler.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@payloadcms/ui/dist/assets/payload-favicon-dark.png");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@payloadcms/ui/dist/assets/payload-favicon-light.png");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@payloadcms/ui/dist/assets/payload-favicon.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@payloadcms/ui/dist/assets/static-og-image.png");
;
import(/* webpackMode: "eager", webpackExports: ["Banner"] */ "/app/node_modules/@payloadcms/ui/dist/elements/Banner/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/node_modules/@payloadcms/ui/dist/elements/Button/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Card"] */ "/app/node_modules/@payloadcms/ui/dist/elements/Card/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["FolderTableCellClient"] */ "/app/node_modules/@payloadcms/ui/dist/elements/FolderView/Cell/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["Locked"] */ "/app/node_modules/@payloadcms/ui/dist/elements/Locked/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@payloadcms/ui/dist/exports/client/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["TranslateButton"] */ "/app/src/components/admin/TranslateButton.tsx");
